import React, { useState, useEffect } from 'react';

function FuncArea() {
    const [time, timeCount] = useState(0);
    const [isRunning, setIsRunning] = useState(true);
    useEffect(() => {
        if (isRunning) {
            const counter = setInterval(() => {
                timeCount(time + 1);
            }, 1000);
            return () => clearInterval(counter);
        }
    });
    const status = () => {
        setIsRunning(!isRunning);
    };
    const reStart = () => {
        window.location.reload();
    };

    return (
        <div className="funcArea">
            <div className="time">
                <span id="timeWord">TIME</span>
                <span id="timeMath">{Math.floor(time / 60)}:{time % 60 < 10 ? `0${time % 60}` : time % 60}</span>
                <input id="status" className="funBtn" type="button" value={isRunning ? 'UNDO' : 'CONTINUE'} onClick={status} />
            </div>
            <div className="start">
                <input className="funBtn" type="button" value="RESTART" onClick={reStart} />
                <input className="funBtn" type="button" value="NEW GAME" />
            </div>
        </div>
    );
}

export default FuncArea;
